"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onceDeviceReady = exports.device = exports.Feature = void 0;
exports.implement = implement;
const tslib_1 = require("tslib");
const web_device_1 = require("../../internal/adapters/web-device");
var feature_1 = require("./features/feature");
Object.defineProperty(exports, "Feature", { enumerable: true, get: function () { return feature_1.Feature; } });
tslib_1.__exportStar(require("./features/types"), exports);
// that's intentionally mutable
// eslint-disable-next-line import/no-mutable-exports
exports.device = new web_device_1.WebDevice();
let resolvePromise;
exports.onceDeviceReady = new Promise((r) => {
    resolvePromise = r;
});
function implement(_device) {
    exports.device = _device;
    resolvePromise(exports.device);
}
//# sourceMappingURL=index.js.map